import { FC, ReactNode } from 'react';

interface StatusBlockProps {
  icon: ReactNode;
  title: string;
  description?: string | null;
  tone?: 'default' | 'success';
}

export const StatusBlock: FC<StatusBlockProps> = ({
  icon,
  title,
  description,
  tone = 'default'
}) => (
  <div
    aria-live="polite"
    className={`flex flex-col items-center justify-center text-center p-10 rounded-xl ${
      tone === 'success' ? 'bg-emerald-50 border border-emerald-200' : 'bg-gray-50'
    }`}
  >
    <div className="mb-3">{icon}</div>
    <p
      className={`text-base font-semibold ${
        tone === 'success' ? 'text-emerald-800' : 'text-gray-800'
      }`}
    >
      {title}
    </p>
    {description && <p className="text-sm text-gray-500 mt-1">{description}</p>}
  </div>
);
